import React from 'react';
import PropTypes from 'prop-types';
import { Card,CardHeader, CardBody, CardTitle, ListGroup, ListGroupItem } from 'reactstrap';
import { Collapse, Tooltip,Empty } from 'antd';

const { Panel } = Collapse;

ConceptWiseProgress.propTypes = {
    heading: PropTypes.string,
    items: PropTypes.array,
    showInfoIcon: PropTypes.bool,
}

ConceptWiseProgress.defaultProps = {
    heading: 'Heading',
    items: [],
    showInfoIcon: false,
};

function ConceptWiseProgress({ heading, items, showInfoIcon, subjAll,category }) {

    // let listItems;
    // if(items.length !== 0 ){
    // listItems = items.map((item, i) => (
    //     <ListGroupItem key={i}>
    //         <span className="font-weight-bold pull-left">{item.subject || 'NA'}</span>
    //         <span className="pull-right">Knowledge Wealth = {item.knowledgeWealth || 0} </span> <br />
    //         <span>{item.chapter} </span>
    //         <span className="pull-right">Avg Knowledge Wealth = {item.avgKnowledgeWealth || 0} </span> <br />
    //     </ListGroupItem>
    // ));
    // }else{
    //     listItems = (
    //         <ListGroupItem>
    //             <span>No data found.</span>
    //         </ListGroupItem>
    //     )
    // }

    let newListItem
    if(category ==='bestperformance'){
        console.log(subjAll);
        if (subjAll !== undefined && subjAll.length !==0) {
            newListItem = (
    
                <Panel header={subjAll[0].subject}>
                    {subjAll.slice(0,3).map((item, i) => (
                     <ListGroupItem key={i} style={{minHeight: 104}}>
                        <span className="font-weight-bold pull-left">Chapter: {item.chapter|| 'NA'}</span>
                        <span className="pull-right">Score % = {item.knowledgeWealth || 0} </span> <br />
                        <span className="pull-right"><Tooltip>Global Average Score %&nbsp;<Tooltip title="It depicts the global average score of all users in STEPapp."> <icon className="icon-inform text-icon dash-icon-inform" aria-hidden="true"></icon> </Tooltip></Tooltip> = {item.avgKnowledgeWealth || 0} </span> <br />
                     </ListGroupItem> 
                    ))
                    }
                </Panel>
            )        
        }else{
            newListItem = (
                <ListGroupItem>
                    {/* <span>No data found.</span> */}
                    <Empty />
                </ListGroupItem>
            )
        }

    }else{
        if (subjAll !== undefined) {
            newListItem = subjAll.map((item, i) => (
    
                <Panel header={item.subject} key={i}>
                     {item.score.map((itemnew, i1) => (
                        //  console.log(itemnew, i1)
                    <ListGroupItem key={i1}>
                         <div className="row" >
                         {/* <div className={`subject-${mcqSubjectNames(item.subjectName.toLowerCase())} text-left col-md-12`} >
                           <icon className={`circle-icon-accordian pos-right-top icon-${mcqSubjectNames(item.subjectName.toLowerCase())}`} /> */}
                         
                              <div className="col-md-12 mb-2">
                                <div className="width-100 text-left detail-label">Chapter:</div>
                                <div className="width-100 text-left detail-value">  {item.score[i1].chapter || 'NA'}</div>
                              </div>

                              <div className="col-md-6  mt-1">
                                <div className="width-100 text-left detail-label">Score % =</div>
                                <div className="width-100 text-left detail-value">  {item.score[i1].knowledgeWealth || 0}</div>
                              </div>

                              <div className="col-md-6  mt-1">
                                <div className="width-100 text-left detail-label">Global Avg Score% =</div>
                                <div className="width-100 text-left detail-value">{item.score[i1].overallKnowledgeWealth || 0} </div>
                              </div>

                         </div>                                               
                    
                    </ListGroupItem>
                     ))}
                </Panel>
    
            ));

            if (subjAll.length === 0) {
                newListItem = (
                    <ListGroupItem>
                        <div className="py-2">
                         <Empty />
                        {/* <span>There is no data to show you right now.</span> */}
                        </div>
                    </ListGroupItem>
                )
            }
        }
    }


    // if (!listItems.length) {
    //     listItems = (
    //         <ListGroupItem>
    //             <span>No data found.</span>
    //         </ListGroupItem>
    //     )
    // }

    return (
        <Card className="card-shadow">
            {/* <Collapse accordion>{newListItem}</Collapse>*/}
             <CardHeader className="dash-card-header">
                    {heading}
                        {showInfoIcon &&
                            <i style={{ 'font-size': '22px', 'position': 'absolute' }} className="ml-2 fa fa-info cursor-pointer" />
                        }
                 </CardHeader>
            <CardBody>
                <div className="py-2">
                <ListGroup>
                    {/* {listItems} */}
                    <Collapse accordion defaultActiveKey={[category === 'bestperformance'?'0':'']}>
                        {newListItem}
                    </Collapse>
                </ListGroup>
                </div>
            </CardBody>
        </Card>
    )
}

export default ConceptWiseProgress;

